export default __webpack_public_path__ + "static/media/fees.bad11a03.svg";